import React from "react";
import { useParams } from "react-router-dom";
import { ApiTask } from "src/api/types";
import Button from "src/components/Button";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import TabNav from "src/components/layout/TabNav";
import useTaskTabs from "src/hooks/api/tasks/useTaskTabs";
import useAuth from "src/hooks/selectors/useAuth";
import useWindowSize from "src/hooks/useWindowSize";

interface TaskCompanyHeadProps extends Translation {
	task: ApiTask;
	button?: any;
}

const TaskCompanyHead = ({ t, task, button }: TaskCompanyHeadProps) => {
	const auth = useAuth();
	const { registration } = useParams() as any;
	const { tabs } = useTaskTabs(task);
	const { isTablet } = useWindowSize();
	if (!auth?.has_subscription) {
		return <></>;
	}

	if (registration && isTablet) {
		return <></>;
	}
	return (
		<div className="flex items-center flex-wrap gap-4">
			<div className="flex-1">
				<TabNav {...{ tabs }} type="company" />
			</div>
			<div className="flex gap-4 items-center">
				<Button
					type="dark"
					to={`/tasks/create?repeat=${task?.hid}`}
					iconOnly
				>
					<i className="fas fa-retweet"></i>
				</Button>

				{button}
			</div>
		</div>
	);
};

TaskCompanyHead.locale = {
	nl: {
		actions: {
			repeat: "Herhalen",
			edit: "Aanpassen",
			hours: "Uren controle",
			invites: "Uitnodigingen",
		},
	},
	en: {
		actions: {
			repeat: "Repeat",
			edit: "Edit",
			hours: "Hour registration",
			invites: "Invites",
		},
	},
};

export default withTranslation(TaskCompanyHead);
